// extracted by mini-css-extract-plugin
module.exports = {"productSliderTitle":"ProductSlider_productSliderTitle__Vj8c1","sliderContainer":"ProductSlider_sliderContainer__PKucB"};